import { useContext, useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { useWhiteboardPages } from './useWhiteboardPages';
import { WhiteboardSessionContext } from '../context/WhiteboardSessionContext';
import { PageTypes } from '../types';

export const useWhiteboardSubtitle = () => {
    const { whiteboardSessionState } = useContext(WhiteboardSessionContext);
    const pages = useWhiteboardPages();
    const { t } = useTranslation('whiteboard');

    return useMemo(() => {
        const { currentPage } = whiteboardSessionState;
        if (!currentPage) {
            return;
        }

        const pageName = currentPage.name;

        if (currentPage.type === PageTypes.Pdf) {
            if (!pages.pdfFiles) {
                return;
            }

            const currentDocument = pages.pdfFiles.find((file) =>
                file.pages.find((page) => page.page_id === currentPage.page_id)
            );
            if (!currentDocument) {
                return;
            }

            const totalPageCount = currentDocument.totalPages;

            if (totalPageCount === 1) {
                return pageName;
            }

            const currentPageIndex =
                currentDocument.pages.findIndex((page) => page.page_id === currentPage.page_id) + 1;

            return t('pdfSubtitle', { pageName, currentPageIndex, totalPageCount });
        }

        if (currentPage.type === PageTypes.Template) {
            return t('controlBoardName');
        }

        return pageName || t('defaultPageName');
    }, [pages.pdfFiles, whiteboardSessionState, t]);
};
